import { useEffect, useReducer } from 'react'
import {
    DataGridLayout,
    Grid,
    UniversalCookieCrumb,
} from '../../UniversalComponents'
import { useTheme, Tab, Tabs, Box } from '@mui/material'
import { useMinimizer } from '../../../context/MinimizeContext'
import { OverviewDashboard } from './components/OverviewDashboard'
import { SingleBoatDashboard } from './components/SingleBoatDashboard'
import { ExecutiveDashboard } from './components/ExecutiveDashboard'
import { FleetViewDashboard } from './components/TabView/FleetViewDashboard'
import FleetHomeView from './components/TabView/Views/FleetHomeView'

interface TabPanelProps {
    children?: React.ReactNode
    dir?: string
    index: number
    value: number
    noPadding?: boolean
}

const TabPanel = (props: TabPanelProps) => {
    const { children, value, index, noPadding, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box
                    sx={{
                        p: noPadding ? 0 : { xs: 1, sm: 2, md: 3 },
                        height: '100%',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    {children}
                </Box>
            )}
        </div>
    )
}

const Dashboard = () => {
    const reducer = (state, newState) => ({ ...state, ...newState })

    const defaultState = {
        currentTab: 0,
        tabName: '',
    }

    const [state, setState] = useReducer(reducer, defaultState)

    const { currentTab, tabName } = state

    const tabs = ['Dashboard', 'Executive Overview']

    const setCurrentTab = (event: React.SyntheticEvent, newValue: number) =>
        setState({ currentTab: newValue, tabName: tabs[newValue] })

    const theme = useTheme()
    const { restoredData } = useMinimizer()

    // useEffect(() => {
    //     if (
    //         restoredData?.id !== undefined &&
    //         restoredData?.tab === 'configuration'
    //     ) {
    //         setState({ currentTab: 0 })
    //     }
    //     if (restoredData?.id !== undefined && restoredData?.tab === 'model') {
    //         setState({ currentTab: 1 })
    //     }
    // }, [restoredData])

    return (
        <DataGridLayout
            cookieCrumbs={<UniversalCookieCrumb customTitle={tabName} />}
            tabBar={
                <Tabs
                    value={currentTab}
                    onChange={setCurrentTab}
                    indicatorColor="secondary"
                    textColor="primary"
                    variant="scrollable"
                    aria-label="Osmosis"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                >
                    <Tab label="Dashboard" />
                    <Tab label="Executive Overview" />
                </Tabs>
            }
            dataGrid={
                <Box sx={{ height: '100%', width: '100%' }}>
                    <TabPanel value={currentTab} index={0}>
                        <FleetHomeView />
                    </TabPanel>
                    <TabPanel value={currentTab} index={1}>
                        <ExecutiveDashboard />
                    </TabPanel>
                </Box>
            }
        />
    )
}

export default Dashboard
